import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LeatherGrippedPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.LeatherGrippedPants.itemName}
      name={AW23.pants.LeatherGrippedPants.itemName}
      price={AW23.pants.LeatherGrippedPants.itemPrice}
      fabric={AW23.pants.LeatherGrippedPants.itemFabric}
      src={AW23.pants.LeatherGrippedPants.sizeChart}
      divId={AW23.pants.LeatherGrippedPants.shopifyDivId}
      mainId={AW23.pants.LeatherGrippedPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.LeatherGrippedPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.LeatherGrippedPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LeatherGrippedPants;
